import { Record } from '../transit'

const ImageNote = new Record({
  reviewed: false,
  type: '',
  image: '',
}, 'imageNote')

export default ImageNote



// WEBPACK FOOTER //
// ./src/common/results/CurrentImageNote.js